<template>
	<div class="about-page">
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />
		<page-content :content="pageContent" />

		<section-title component-class="margin-top-50">
			<h2 v-html="$t('Sentence.AboutPageWhatIsTitle')"></h2>
		</section-title>

		<div class="what-is">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-6 col-sm-12 col-xs-12 image">
						<img src="@/assets/img/what-is.jpg" alt="What is" class="hidden-xl hidden-lg hidden-md" />
					</div>
					<div class="col-md-6 col-sm-12 col-xs-12">
						<div class="description padding-top-50 padding-bottom-50">
							<p v-html="$t('Sentence.AboutPageWhatIsText1')"></p>
							<br />
							<p>
								<span v-html="$t('Sentence.AboutPageWhatIsText2')"></span>
								<a href="#" @click.prevent="openHelpModal">
									{{ $t('Link.ReadMore') }}
								</a>
							</p>
							<br />
							<p v-html="$t('Sentence.AboutPageWhatIsText3')"></p>
							<br />
							<p v-html="$t('Sentence.AboutPageWhatIsText4')"></p>
							<br />
							<p v-html="$t('Sentence.AboutPageWhatIsText5')"></p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="our-services clearfix">
			<div class="container padding-top-50 padding-bottom-30 margin-bottom-20">
				<div class="row">
					<div class="col-md-10 col-md-offset-1">
						<h3 class="text-center margin-bottom-20" v-html="$t('Sentence.AboutPageOurServicesExtraTitle')"></h3>
						<p>{{ $t('Sentence.AboutPageOurServicesExtraText') }}</p>
					</div>
				</div>
			</div>

			<section-title component-class="margin-top-70">
				<h2 v-html="$t('Sentence.AboutPageOurServicesTitle')"></h2>
				<p>{{ $t('Sentence.AboutPageOurServicesText') }}</p>
			</section-title>

			<div class="container padding-top-50 padding-bottom-30 margin-bottom-20">
				<div class="row">
					<div v-for="(service, index) in services" :key="index" class="col-md-4">
						<div class="media">
							<div class="media-left">
								<i class="fa media-object" :class="service.icon" aria-hidden="true"></i>
							</div>
							<div class="media-body">
								<h6 class="media-heading">{{ service.title }}</h6>
								<p>{{ service.text }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="team padding-top-20">
			<section-title component-class="margin-top-50">
				<h2 v-html="$t('Sentence.AboutPageOurTeamTitle')"></h2>
			</section-title>

			<div class="container">
				<div class="row padding-bottom-70">
					<div v-for="(member, index) in team" :key="index" class="col-md-4 col-sm-6 col-xs-12">
						<div class="team-member text-center">
							<img
								:src="'/static/images/team/team-member-' + (index + 1) + '.jpg'"
								:alt="member.first_name + ' ' + member.last_name"
								class="member-thumb"
							/>
							<h5 class="text-center">
								<span class="fw-400">{{ member.first_name }}</span> {{ member.last_name }}
							</h5>
							<p class="text-center">{{ member.role }}</p>
							<ul v-if="member.links" class="padding-bottom-20">
								<li v-for="(value, key) in member.links" :key="key">
									<a :href="value" target="_blank" :title="value">
										<i class="fa" :class="'fa-' + key" aria-hidden="true"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<partners-container v-once />
	</div>
</template>

<script>
import PageContent from '@/components/partials/PageContent'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'
import PartnersContainer from '@/components/sections/PartnersContainer'
import SectionTitle from '@/components/partials/SectionTitle'

export default {
	name: 'About',
	components: {
		PageContent,
		PageTitle,
		PartnersContainer,
		SectionTitle,
	},
	mixins: [PageInfo],
	data() {
		return {
			services: [
				{
					title: this.$t('Sentence.AboutPageService1Title'),
					text: this.$t('Sentence.AboutPageService1Text'),
					icon: 'fa-globe',
				},
				{
					title: this.$t('Sentence.AboutPageService2Title'),
					text: this.$t('Sentence.AboutPageService2Text'),
					icon: 'fa-trophy',
				},
				{
					title: this.$t('Sentence.AboutPageService3Title'),
					text: this.$t('Sentence.AboutPageService3Text'),
					icon: 'fa-child',
				},
			],
			team: [
				{
					first_name: 'Andrea',
					last_name: 'Fontana Donatelli',
					role: '',
					links: {
						// facebook: '#',
						linkedin: 'https://www.linkedin.com/in/andrea-fontana-donatelli-768948172/',
					},
				},
				{
					first_name: 'Andrea',
					last_name: 'Landonio',
					role: '',
					links: {
						facebook: 'https://www.facebook.com/andrea.landonio',
						// 'google-plus': '#',
						// twitter: '#',
						// linkedin: '#',
					},
				},
				{
					first_name: 'Andrea',
					last_name: 'Violini',
					role: '',
					links: {
						// facebook: '#',
						// 'google-plus': '#',
						// twitter: '#',
						linkedin: 'https://www.linkedin.com/in/andreaviolini/',
					},
				},
			],
		}
	},
	methods: {
		openHelpModal() {
			// Emit open info modal event
			this.$root.$emit('open-help-modal', { name: 'success-fee' })
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/service/About.vue